export class Spinner extends Phaser.GameObjects.Container {
  private curveLeft: Phaser.Curves.Path | undefined;
  private curveRight: Phaser.Curves.Path | undefined;
  private followerRight: Phaser.GameObjects.PathFollower | undefined;
  private followerLeft: Phaser.GameObjects.PathFollower | undefined;
  private controlPanel;
  private background: any;
  private winningNumbers: any;
  private readonly screenWidth;
  private readonly screenHeight;
  constructor(scene, screenWidth, screenHeight, drawResult) {
    super(scene);
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    if (!drawResult || drawResult.length !== 3) {
      this.showErrorMessage('Invalid draw result');
      return;
    }
    this.winningNumbers = drawResult.slice(0, 2);
    this.createBody();
  }
  showErrorMessage(message) {
    console.log(message);
  }
  createBody() {
    this.addBackground();
    this.curveLeft = new Phaser.Curves.Path(100, this.screenHeight);
    this.curveRight = new Phaser.Curves.Path(this.screenWidth - 100, this.screenHeight);
    this.curveLeft.ellipseTo(100, this.screenHeight / 2, 70, -100, true, 0);
    this.curveRight.ellipseTo(100, this.screenHeight / 2, 100, -70, false, 0);
    const followerRightArray: Phaser.GameObjects.PathFollower[] = [];
    const followerLeftArray: Phaser.GameObjects.PathFollower[] = [];
    const greenBlankBallLeft = this.scene.add
      .image(this.screenWidth / 2 - 205, this.screenHeight / 2 - 5, 'green_blank_ball')
      .setScale(0.4);
    const greenBlankBallRight = this.scene.add.image(this.screenWidth / 2 + 190, this.screenHeight / 2, 'green_blank_ball').setScale(0.4);
    for (let i = 0; i < 10; i++) {
      this.followerRight = this.scene.add.follower(this.curveRight, 0, 0, 'whitenumberball_' + i).setScale(0.9);
      this.followerLeft = this.scene.add.follower(this.curveLeft, 0, 0, 'whitenumberball_' + i).setScale(0.9);
      this.followerRight.startFollow({
        startAt: 0,
        positionOnPath: true,
        duration: 1000,
        yoyo: false,
        repeat: -1,
        ease: 'Linear',
        delay: i * 100,
        rotateToPath: true,
        rotationOffset: -90,
        from: 1,
        to: 0
      });
      this.followerLeft.startFollow({
        positionOnPath: true,
        duration: 1000,
        yoyo: false,
        repeat: -1,
        ease: 'Linear',
        delay: i * 100,
        rotateToPath: true,
        rotationOffset: 90
      });
      followerRightArray.push(this.followerRight);
      followerLeftArray.push(this.followerLeft);
    }
    const wn1: number = this.winningNumbers[0];
    const wn2: number = this.winningNumbers[1];
    const t1: number = 3500 + wn1 * 100;
    const t2: number = 3500 + wn2 * 100;
    const winningNumber1 = this.scene.add
      .image(this.screenWidth / 2 - 205, this.screenHeight / 2, `greennumberball_${wn1}`)
      .setVisible(false);
    const winningNumber2 = this.scene.add
      .image(this.screenWidth / 2 + 205, this.screenHeight / 2, `greennumberball_${wn2}`)
      .setVisible(false);
    this.scene.tweens.add({
      targets: followerRightArray,
      ease: 'Power2',
      completeDelay: t2,
      onComplete: () => {
        for (let i = 0; i < 10; i++) {
          followerRightArray[i].stopFollow();
        }
        greenBlankBallRight.setX(followerRightArray[wn2].pathVector.x).setY(followerRightArray[wn2].pathVector.y + 25);
        showWinningNumber();
      }
    });
    this.scene.tweens.add({
      targets: followerLeftArray,
      ease: 'Power2',
      completeDelay: t1,
      onComplete: () => {
        for (let i = 0; i < 10; i++) {
          followerLeftArray[i].stopFollow();
        }
        greenBlankBallLeft.setX(followerLeftArray[wn1].pathVector.x).setY(followerLeftArray[wn1].pathVector.y - 25);
      }
    });
    const showWinningNumber = () => {
      this.scene.tweens.add({
        targets: followerLeftArray,
        x: -1000,
        duration: 700,
        delay: 1500,
        ease: 'Power2',
        repeat: 0,
        yoyo: false,
        onStart: () => {
          followerLeftArray.forEach((_, index) => {
            followerLeftArray[index].setVisible(false);
          });
        },
        onComplete: () => {
          followerLeftArray.forEach((_, index) => {
            followerLeftArray[index].destroy();
          });
        }
      });
      this.scene.tweens.add({
        targets: followerRightArray,
        x: 1000,
        duration: 700,
        delay: 1500,
        ease: 'Power2',
        repeat: 0,
        yoyo: false,
        onStart: () => {
          followerRightArray.forEach((_, index) => {
            followerRightArray[index].setVisible(false);
          });
        },
        onComplete: () => {
          followerRightArray.forEach((_, index) => {
            followerRightArray[index].destroy();
          });
        }
      });
      this.scene.tweens.add({
        targets: this.background,
        ease: 'Power2',
        delay: 1500,
        completeDelay: 1500,
        onComplete: () => {
          this.background.setVisible(false);
          winningNumber1.setVisible(true);
          winningNumber2.setVisible(true);
          greenBlankBallLeft.setVisible(false);
          greenBlankBallRight.setVisible(false);
        }
      });
      this.scene.tweens.add({
        targets: winningNumber1,
        ease: 'Power2',
        completeDelay: 1000,
        delay: 1500,
        props: {
          scale: 1.2,
          x: winningNumber1.x + 100
        },
        onComplete: () => {
          this.nextScene(winningNumber1, winningNumber2);
        }
      });
      this.scene.tweens.add({
        targets: winningNumber2,
        ease: 'Power2',
        completeDelay: 1000,
        delay: 1500,
        props: {
          scale: 1.2,
          x: winningNumber2.x - 100
        }
      });
    };
  }
  nextScene(winningNumber1, winningNumber2) {
    this.scene.tweens.add({
      targets: [winningNumber1, winningNumber2],
      y: this.screenHeight,
      duration: 500,
      ease: 'Sine.easeOut',
      yoyo: false,
      onComplete: () => {
        this.scene.scene.start('BonusMultiplierScene');
      }
    });
  }
  addBackground() {
    this.background = this.scene.add.sprite(this.screenWidth / 2, this.screenHeight / 2, 'backgroundArc');
    this.background.setDisplaySize(this.screenWidth, this.screenHeight);
  }
  updateReplayButton() {
    this.controlPanel.button.setTexture('replay');
  }
}
